import { defineComponent as _defineComponent } from 'vue'
import { computed, inject } from 'vue';
import { storeToRefs } from 'pinia';
import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import type { ComputedRef, Ref } from 'vue';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useExperiment } from '@/libraries/experiment';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderFilterButton',
  props: {
    variant: null,
    buyboxType: null,
    userProvidersOnly: { type: Boolean },
    selectedCount: null,
    totalCount: null,
    filterActive: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	variant: string | null;
	buyboxType: 'grid' | 'list';
	userProvidersOnly?: boolean;
	selectedCount?: number;
	totalCount?: number;
	filterActive?: boolean;
};





const { providersByShortName } = storeToRefs(useConstantStore());
const filterStore = useFilterStore();
const { selectedProvidersByType } = filterStore;
const { currentFilters, selectedProvidersType } = storeToRefs(filterStore);
const { settingsProvider } = storeToRefs(useUserStore());

const buyboxProviderMenuOpen = inject<Ref<boolean> | null>('buyboxProviderMenuOpen', null);
const buyboxOfferProviders = inject<ComputedRef<string[]> | null>('buyboxOfferProviders', null);
const buyboxProviderFilter = inject<Ref<string[] | null> | null>('buyboxProviderFilter', null);

const filterOpen = computed(() => buyboxProviderMenuOpen?.value ?? false);

const selectedProviders = computed(() => selectedProvidersByType(selectedProvidersType.value ?? undefined));

const { trackEvent } = useExperiment('EXP_PROVIDER_BUYBOX');

const providers = computed(() => {
	if (props.userProvidersOnly) {
		return selectedProvidersByType('my_services');
	}

	if (props.variant === 'variant_3' && buyboxOfferProviders?.value?.length) {
		return buyboxOfferProviders.value.map(shortName => providersByShortName.value[shortName]).filter(Boolean);
	}

	if (props.variant === 'variant_1' || props.variant === 'variant_2') {
		const shortNames = buyboxProviderFilter?.value ?? settingsProvider.value ?? [];
		return shortNames.map(shortName => providersByShortName.value[shortName]).filter(Boolean);
	}

	if (currentFilters.value.providers.length) {
		return currentFilters.value.providers.map(shortName => providersByShortName.value[shortName]);
	}

	return selectedProviders.value;
});

const FALLBACK_SHORT_NAMES = ['nfx', 'dnp', 'atp'];

const providersToDisplay = computed(() => {
	const list = providers.value.slice(0, 3);
	if (list.length > 0) return list;
	if (props.variant === 'variant_1' || props.variant === 'variant_2') {
		return FALLBACK_SHORT_NAMES.map(s => providersByShortName.value[s]).filter(Boolean);
	}
	return list;
});

const selectedProvidersCount = computed(() => {
	if (props.selectedCount !== undefined) return props.selectedCount;

	// const filteredProvidersCount = currentFilters.value.providers.length;
	// if (filteredProvidersCount && !props.userProvidersOnly) {
	// 	return `${filteredProvidersCount}/${selectedProviders.value.length}`;
	// }

	return providers.value.length;
});

const isActive = computed(() => {
	if (props.filterActive !== undefined) return props.filterActive;
	if (props.totalCount !== undefined) {
		return (props.selectedCount as number) < props.totalCount;
	}
	if (props.selectedCount !== undefined) {
		return props.selectedCount < providers.value.length;
	}
	return selectedProvidersType.value !== 'all' || currentFilters.value.providers.length > 0;
});

const _buyboxType = computed(() => {
	if (props.buyboxType === 'grid') return 0;
	if (props.buyboxType === 'list') return 1;
	return 0;
});

function handleClick() {
	emit('click');
	if (props.variant === 'variant_1' || props.variant === 'variant_3') filterOpen.value = !filterOpen.value;

	if (!!filterOpen.value && (props.variant === 'variant_1' || props.variant === 'variant_3')) {
		trackEvent({
			action: 'click',
			label: 'provider_filter_open',
			value: _buyboxType.value,
		});
	}

	if (!filterOpen.value && props.variant === 'variant_1') {
		trackEvent({
			action: 'click',
			label: 'provider_filter_close',
			value: props.buyboxType === 'grid' ? 0 : 1,
		});
	}

	if (!filterOpen.value && props.variant === 'variant_3') {
		trackEvent({
			action: 'click',
			label: 'provider_filter_close',
			property: providers.value
				.filter(poo => buyboxProviderFilter?.value?.includes(poo.shortName))
				.map(poo => poo.technicalName)
				.join(', '),
			value: props.buyboxType === 'grid' ? 0 : 1,
		});
	}
}

const onVisibleCallback = {
	callback: (isVisible: boolean) => {
		if (isVisible) {
			trackEvent({
				action: 'impression',
				value: _buyboxType.value,
			});
		}
	},
};

return { __sfc: true,props, emit, providersByShortName, filterStore, selectedProvidersByType, currentFilters, selectedProvidersType, settingsProvider, buyboxProviderMenuOpen, buyboxOfferProviders, buyboxProviderFilter, filterOpen, selectedProviders, trackEvent, providers, FALLBACK_SHORT_NAMES, providersToDisplay, selectedProvidersCount, isActive, _buyboxType, handleClick, onVisibleCallback, ProviderIcon, faChevronDown, faChevronUp, faTimes }
}

})